import React from 'react'
import { Routes, Route, Navigate, Outlet } from 'react-router-dom'
import PermissionsService from '../auth/PermissionsService'
import { PageTitle } from '../../../_metronic/layout/core'
import { ClientCommission } from './ClientCommission'

export const ClientCommissionPage = () => {
  const { hasProductConfigCommissionPermission } = PermissionsService.getPermissions() || {}

  return (
    <Routes>
      <Route element={<Outlet />}>
        {hasProductConfigCommissionPermission ? (
          <Route
            path='client-commission'
            element={
              <>
                <ClientCommission />
                <PageTitle>Comisión Personalizada del Cliente</PageTitle>
              </>
            }
          />
        ) : (
          <Route path='client-commission' element={<Navigate to='/error/403' replace />} />
        )}
      </Route>
      <Route index element={<Navigate to='client-commission' replace />} />
    </Routes>
  )
}
export default ClientCommissionPage
